import React, { useEffect } from 'react';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Contact from './components/Contact';
import Services from './components/Services'; // This is your 'Company' component
import CaseStudies from './components/CaseStudies';
import logo8 from './Images/YellowrayLogo8.png';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        
        {/* ================= HEADER & NAVIGATION ================= */}
        <header className="App-header">
          <div className="header-logo">
            {/* Using Link instead of <a> makes the page switch instantly without reloading */}
            <Link to="/">
              <img src={logo8} alt="Yellow Ray Consulting Logo" className="logo" />
            </Link>
          </div> 
          
          <nav className="header-nav">
            <Link to="/">Home</Link>
            <Link to="/services">Company</Link>
            <Link to="/case-studies">Case Studies</Link> {/* Boss's new button */}
            <Link to="/contact">Contact Us</Link>
          </nav>
        </header>

        {/* ================= MAIN CONTENT AREA ================= */}
        <div className="App-content"> 
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>

        {/* ================= FOOTER ================= */}
        <footer>
          <div className="footer-content">
            <ul className="social-icons">
              <li>
                <a
                  href="https://www.linkedin.com/company/yellowray-consulting-group/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-linkedin fa-2x"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://yellowray.solutions"
                  target="_blank"
                  rel="noreferrer"
                  data-tooltip="Visit Our Solutions Site"
                >
                  <i className="fas fa-globe fa-2x"></i>
                </a>
              </li>
            </ul>
            <p className="copyright-text">
              &copy; 1986-{new Date().getFullYear()} Yellow Ray Consulting Group Inc. All Rights Reserved.
            </p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;